<template>
  <div>
    <b-card>
      <h4
        class="mb-4"
        :class="is_unactive_card_qr ? 'text-danger' : 'text-primary'"
      >
        {{
          is_unactive_card_qr
            ? $t("reception.unactive-card-qr-text")
            : $t("reception.patient-card-qr")
        }}
        <span class="text-primary"> </span>
      </h4>
      <b-col
        class="pb-2 pt-0 qrCol d-flex justify-content-center"
        cols="12"
        md="12"
        sm="12"
      >
        <qrcode
          class="qrcodeStyle"
          :size="100"
          :text="`https://vesalio-private.aswar.solutions/patient-card-by-qr/${patientCard.id}`"
        ></qrcode>
      </b-col>
      <b-button
        v-b-toggle.sidebar-send-invoice
        variant="primary"
        @click="generateReport()"
        class="p-1 mt-75"
        block
      >
        {{ $t("common.print") }}
      </b-button>
      <b-row>
        <b-col> </b-col>
      </b-row>
    </b-card>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="printQR"
    >
      <section
        dir="ltr"
        style="font-size: 18px; height: 100vh"
        class="pdf-content font-modify m-5"
        slot="pdf-content"
      >
        <h1 class="text-center text-dark mb-2 mt-1">مستشفى الوزيرية الاهلي</h1>

        <div
          class="d-flex justify-content-center flex-column align-items-center mt-5"
        >
          <h4
            v-if="is_unactive_card_qr"
            class="mb-4 text-danger"
            dir="rtl"
            style="font-size: 18px"
          >
            هذة QR خاص بأخر بطاقة تم إيقافها للمريض
          </h4>
          <qrcode
            class="qrcodeStyle mb-2"
            :size="300"
            :text="`https://vesalio-private.aswar.solutions/patient-card-by-qr/${patientCard.id}`"
          ></qrcode>

          <h1 class="text-center text-dark mb-2 mt-2">
            {{ getNestedProperty(patientCard, 'patient.name') }}
          </h1>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import { BCard, BRow, BCol, BButton } from "bootstrap-vue";
import VueQRCodeComponent from "vue-qrcode-component";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    qrcode: VueQRCodeComponent,
    VueHtml2pdf,
  },

  data() {
    return {
      addForm: {
        patient_id: "",
      },
      params: {
        form: {},
        path: "",
      },
     };
  },

  props: ["patientCard", "is_unactive_card_qr"],
  mounted() {},

  methods: {
    getNestedProperty(obj, path, defaultValue = "") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      return result;
    },
    generateReport() {
      this.$refs.printQR.generatePdf();
    },

    stopCard() {
      this.addForm.patient_id = this.patientCard.patient_id;
      this.params.path = `/patientCard/${this.patientCard.id}`;
      this.params.form = this.addForm;
      this.$store
        .dispatch("put", this.params)
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Card Stopped",
              variant: "success",
              text: error.response.data[item][0],
            },
          });
        })
        .catch((error) => {
          if (error.response.status === 400) {
            for (let item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "validation error",
                  variant: "danger",
                  text: error.response.data[item][0],
                },
              });
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>
